import { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import type { ApiInstance, LoginApiResult, LoginBody } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export const useUserLogin = (api: ApiInstance, params?: LoginBody, options?: CustomUseQueryOptions<LoginApiResult>) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(params),
    queryKey: [queryKey, 'UserLogin', params],
    queryFn: async ({ signal }) => {
      const { data } = await api.user.login(params!, { signal });
      return data;
    },
  });
};
